<pk-broker-modal>
	<ng-template #headerTemplate>
		<h5 class="modal-title">
			@if (!showSuccess) {
				Please tell us what you think
			} @else {
				Thank you!
			}
		</h5>
	</ng-template>
	<ng-template #bodyTemplate>
		<pk-broker-loader [show]="loading"></pk-broker-loader>
		@if (!loading) {
			<form [formGroup]="formGroup">
				<div class="container-fluid">
					@if (!showSuccess) {
						<div class="row">
							<div class="col">
								<p>{{ feedbackType.header }}</p>
								<p class="mb-4">Please tell us what you think:<br /><strong>Was that notification helpful to you?</strong></p>
							</div>
						</div>
						@for (feedbackTypeOption of feedbackType.feedbackTypeOptions; track feedbackTypeOption.id) {
							<div class="row">
								<div class="col form-element-container">
									<div class="custom-control custom-radio">
										<input
											type="radio"
											[id]="feedbackTypeOption.id"
											formControlName="feedbackTypeOption"
											class="custom-control-input"
											[value]="feedbackTypeOption" />
										<label [for]="feedbackTypeOption.id" class="custom-control-label">{{ feedbackTypeOption.name }}</label>
									</div>
								</div>
							</div>
						}
						@if (form.feedbackTypeOption.value?.showBody) {
							<div class="row">
								<div class="col form-element-container">
									<label for="otherSpecify">Please specify</label
									><textarea id="otherSpecify" rows="6" class="form-control" formControlName="response" maxlength="1000"></textarea>
									<span>characters left {{ charactersLeft }}/1000</span>
									<div class="invalid-feedback" *ngIf="err.response">Please add a message, and no more than 1000 characters, for your feedback.</div>
								</div>
							</div>
						}
					} @else {
						<div class="row">
							<div class="col">
								<p class="mb-0">{{ feedbackType.successMessage }}</p>
							</div>
						</div>
					}
				</div>
			</form>
		}
	</ng-template>
	<ng-template #footerTemplate>
		@if (showSuccess) {
			<button type="button" class="btn btn-primary w-100" aria-label="Close" (click)="close()">Close</button>
		} @else {
			<button type="button" class="btn btn-primary w-100" (click)="submit()" [disabled]="submitDisabled">{{ submitText }}</button>
		}
	</ng-template>
</pk-broker-modal>
